import { BoxV2 as Box, Button, Flex } from 'portal-commons';
import { FunctionComponent } from 'react';
import { faHandsClapping } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Modal from '@/components/ModalV2';

interface BrandRegisteredModalProps {
  open?: boolean;
  onNavigate?: () => void;
  testId?: string;
}

const BrandRegisteredModal: FunctionComponent<BrandRegisteredModalProps> = ({
  open = false,
  onNavigate,
  testId,
}) => (
  <Modal
    open={open}
    sx={{
      width: '528px',
      padding: '24px',
      borderRadius: '8px',
      overflow: 'auto',
    }}
    data-testid={testId}
  >
    <Flex
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        gap: 'xl',
        width: '100%',
        color: 't.black90',
        fontWeight: 400,
      }}
    >
      <Box
        sx={{
          fontSize: '64px',
          color: 't.blue100',
        }}
      >
        <FontAwesomeIcon icon={faHandsClapping} />
      </Box>
      <Box sx={{ fontSize: 'H600' }}>Brand Registered Successfully</Box>
      <Box sx={{ width: '100%', fontSize: 'H400', textAlign: 'center' }}>
        You have successfully registered the brand, but its identity status will
        be shown as pending until brand verification is complete. For updates on
        the identity status, check the Brand Details page.
      </Box>
      <Button shape="square" onClick={onNavigate}>
        Go to Brand Details
      </Button>
    </Flex>
  </Modal>
);

export default BrandRegisteredModal;
